/**
 * Created by wwei on 2017-06-29.
 */
import React, { Component } from 'react';
import Loading from './Loading.js';

class Waiting extends Component {

    render() {
        return (
            <div style={{"width":"100%", "height":"100%", "textAlign":"center",
                            "bottom": 0, "left": 0, "margin": "auto",
                            "position": "absolute", "right": 0, "top": 0}}>
                <div style={{"width":"100%", "height":"20px", "display":"inline-block", "marginTop": "20%"}}>
                    <Loading size="large" tip="Loading..."/>
                </div>
            </div>
        )
    }
}

export default Waiting;


// WEBPACK FOOTER //
// ./src/common/components/Waiting.js